$(function() {
  var stocks = ["GOOG", "AAPL", "GE", "MSFT", "FB"];
  var current = 0;

  var rates;
  var graphs;

  var $stock_holder = $("#stock_holder");
  var $tabs = $(".stocks li a");

  var selectCurrentTab = function() {
    var i;
    for (i = 0; i < stocks.length; ++i) {
      if (i != current) $($tabs[i]).removeClass("selected");
      else $($tabs[i]).addClass("selected");
    }
  };

  var reloadCurrency = function() {
    if (rates == undefined) {
      ajax_call(
        {
          module: "StockRate",
          action: "getRates",
          type: 2
        },
        function(data) {
          rates = data;
          reloadCurrency();
        },
        "json"
      );
    } else {
      var data = rates[stocks[current]];
      //			console.log(stocks.length, current, data, rates)
      $stock_holder.fadeOut("fast", function() {
        $stock_holder.html(data);
        $stock_holder.fadeIn("fast");
      });
      selectCurrentTab();
    }
  };

  $(".stocks .leftarrow").click(function() {
    current = (current - 1 + stocks.length) % stocks.length;
    reloadCurrency();
    return false;
  });

  $(".stocks .rightarrow").click(function() {
    current = (current + 1) % stocks.length;
    reloadCurrency();
    return false;
  });

  $tabs.click(function() {
    var i;
    var curr = $(this).html();

    for (i = 0; i < $tabs.length; ++i) {
      //najhlupejsi sposob
      //			console.log($tabs[i]);
      if (curr == $($tabs[i]).html()) {
        current = i;
        reloadCurrency();
        break;
      }
    }
    return false;
  });
});
